import React from 'react';
import 'normalize.css';
import GlobalStyles from '../styles/GlobalStyles';
// import { Footer } from './Footer';
import type { PageProps } from 'gatsby';
import { Nav } from './Nav';
import { Footer } from './Footer';
import Typography from '../styles/Typography';
import { graphql } from 'gatsby';

interface LayoutProps extends PageProps {
  data: any;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <GlobalStyles />
      <Typography />
      <div>
        <div>{children}</div>
      </div>
    </>
  );
}
